export const keywordToRoute = {
   // Page d'accueil
  accueil: "/",
  bienvenue: "/",
  présentation: "/",

  // À propos
  apropos: "/mksp/about",
  Apropos: "/mksp/about",
  qui: "/mksp/about",
  mission: "/mksp/about",
  vision: "/mksp/about",
  histoire: "/mksp/about",
  technologie: "/mksp/about",
  Technologie: "/mksp/about",

  // Contact
  contact: "/mksp/contact",
  Contact: "/mksp/contact",
  email: "/mksp/contact",
  téléphone: "/mksp/contact",
  Téléphone: "/mksp/contact",
  Telephone: "/mksp/contact",
  telephone: "/mksp/contact",
  adresse: "/mksp/contact",
  message: "/mksp/contact",
  Message: "/mksp/contact",
  
  //mksp
  Universités: "/mksp/guide/university",
  universités: "/mksp/guide/university",
  universites: "/mksp/guide/university",
  universite: "/mksp/guide/university",
  university: "/mksp/guide/university",
  Universites: "/mksp/guide/university",
  Universite: "/mksp/guide/university",
  University: "/mksp/guide/university",


  Logements: "/mksp/guide",
  Logement: "/mksp/guide",
  logements: "/mksp/guide",
  logement: "/mksp/guide",

  Visa: "/mksp/guide",
  visa: "/mksp/guide",




  // Services
  // services: "/mksp/services",
  // offres: "/mksp/services",
  // solution: "/mksp/services",
  // accompagnement: "/mksp/services",
  // prestation: "/mksp/services",

  // // Blog ou actualités
  // blog: "/mksp/blog",
  // article: "/mksp/blog",
  // nouvelles: "/mksp/blog",
  // actu: "/mksp/blog",
  // publication: "/mksp/blog",

  // // Équipe
  // equipe: "/mksp/equipe",
  // membres: "/mksp/equipe",
  // staff: "/mksp/equipe",
  // fondateur: "/mksp/equipe",

  // // FAQ
  // faq: "/mksp/faq",
  // questions: "/mksp/faq",
  // aide: "/mksp/faq",

  // // Mentions légales ou politique
  // legal: "/mksp/legal",
  // mentions: "/mksp/legal",
  // politique: "/mksp/legal",
  // confidentialité: "/mksp/legal",
};